import { render, staticRenderFns } from "./service-point.scene.vue?vue&type=template&id=8c3d092e"
import script from "./service-point.scene.ts?vue&type=script&lang=ts&external"
export * from "./service-point.scene.ts?vue&type=script&lang=ts&external"
import style0 from "./service-point.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
